module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    staticStyle: {
      "margin": "0",
      "padding": "0 10px"
    }
  }, [_c('el-form', {
    ref: "auditForm",
    staticClass: "small-space",
    attrs: {
      "model": _vm.auditForm,
      "label-position": "left",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核意见",
      "prop": "jcCzxmc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请填写审核意见",
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.auditForm.opinion),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "opinion", $$v)
      },
      expression: "auditForm.opinion"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.audit('1')
      }
    }
  }, [_vm._v("通 过")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.audit('2')
      }
    }
  }, [_vm._v("驳 回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe04836"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/audit.vue
// module id = 1815
// module chunks = 502